import React from 'react';

import { SubstantiationRatePayload } from '../NewStatistics.types';

import { SubstantiationRateStatistic } from './components';
import { useSubstantiationRateLogic } from './hooks';

interface Props {
  data: null | SubstantiationRatePayload;
  isLoading?: boolean;
}
const SubstantiationRateStatisticContainer: React.FC<Props> = ({ data, isLoading = false }) => {
  const { options, currentRange, setCurrentRange, percents } = useSubstantiationRateLogic({ data });

  return (
    <SubstantiationRateStatistic
      isLoading={isLoading}
      percents={percents}
      options={options}
      currentRange={currentRange}
      onChangeRange={setCurrentRange}
    />
  );
};

export default SubstantiationRateStatisticContainer;
